// extracted by mini-css-extract-plugin
module.exports = {"root":"ReviewAndAppLinks_root__KtcsO"};